import styled from 'styled-components';

import Block from '../../structure/Block';
import T2 from '../../titles/T2';

export const StyledWrapper = styled.div<{ paddingTopContent: number }>`
  margin-top: ${({ paddingTopContent }) => 96 - paddingTopContent}px;
`;

export const StyledTitle = styled(T2)`
  text-align: center;
  margin-top: 36px;
`;

export const StyledErrorMessage = styled(Block).attrs({ white: true })`
  text-align: center;
  font-size: 17px;
  padding: 48px 32px 48px;
`;

export const StyledText = styled.span``;

export const StyledActionBar = styled.div`
  margin-top: 36px;
`;
